export default __webpack_public_path__ + "static/media/gama-logo.7aaec40b.svg";